import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { AxiosError } from 'axios';
import { BaseError } from '@utils/types/shared/base.ts';
import { UserResponse } from '@utils/types/profile/user-profile.ts';

export function updateMe(userData: UserResponse): Promise<UserResponse> {
  return Axios.post<UserResponse>(POST_URL().updateMe, userData).then(
    res => res.data
  );
}

export function useUpdateMe() {
  const queryClient = useQueryClient();

  return useMutation<UserResponse, AxiosError<BaseError>, UserResponse>(
    updateMe,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['user']);
      },
      useErrorBoundary: false
    }
  );
}
